module.exports = __webpack_public_path__ + "deb9a60ff271f3fc44d2c16468a969f2.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-princess-s.png
// module id = 2276
// module chunks = 0